/* Checken ob leer und löschen */
function removeEmptyTags(selectorOuter, selectorInner) {
    $(selectorOuter).each(function () {
        if (!$.trim($(this).find(selectorInner).html()).length) {
            $(this).remove();
        }
    });
}